module.exports = __webpack_public_path__ + "static/img/li8_3.e1f908b3.png";